import React from 'react';
import { useNavigate } from "react-router-dom";
import { MyMVariantLabel } from '../ui-elements/MyMLabel';
import { NavigateLink } from './NavigateLink';
import NotifyMessagePage from './NotifyMessagePage';

/**
 * リンク付きメッセージ通知ページ Component
 */
export const NotifyMessageLinkPage = (props) => {

  const navigate = useNavigate();
  const { message, linkText, navigateTo, onClick } = props;

  return (
    <NotifyMessagePage>
      <MyMVariantLabel className='mb-3' variant='h6' >{message}</MyMVariantLabel>
      <NavigateLink onClick={() => { navigateTo ? navigate(navigateTo) : onClick(); }}>{linkText}</NavigateLink>
    </NotifyMessagePage>
  );
};